import React, { createContext, useContext, useState, ReactNode } from "react";

type Denomination = "BTC" | "SATS";

interface DenominationContextType {
  denomination: Denomination;
  toggleDenomination: () => void;
  formatBitcoin: (amount: number) => string;
}

const DenominationContext = createContext<DenominationContextType | undefined>(
  undefined
);

export function DenominationProvider({ children }: { children: ReactNode }) {
  const [denomination, setDenomination] = useState<Denomination>("BTC");

  const toggleDenomination = () => {
    setDenomination((prev) => (prev === "BTC" ? "SATS" : "BTC"));
  };

  const formatBitcoin = (btcAmount: number) => {
    if (denomination === "SATS") {
      const sats = Math.round(btcAmount * 100000000);
      return sats.toLocaleString().padStart(9, " ") + " sats";
    }
    return btcAmount.toFixed(8).padStart(10, " ") + " BTC";
  };

  return (
    <DenominationContext.Provider
      value={{ denomination, toggleDenomination, formatBitcoin }}
    >
      {children}
    </DenominationContext.Provider>
  );
}

export function useDenomination() {
  const context = useContext(DenominationContext);
  if (context === undefined) {
    throw new Error(
      "useDenomination must be used within a DenominationProvider"
    );
  }
  return context;
}
